import { asSequence2jzw5xbq99nu9 as asSequence } from '../collections/_Arrays.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Sequence1quqbxersk0bb as Sequence } from './Sequence.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { EmptyIterator_instancex3sopkoseugu as EmptyIterator_instance } from '../collections/CollectionsKt.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from '../collections/AbstractIterator.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../collections/HashSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function generateSequence(seed, nextFunction) {
  var tmp;
  if (seed == null) {
    tmp = EmptySequence_instance;
  } else {
    tmp = new (GeneratorSequence())(() => seed, nextFunction);
  }
  return tmp;
}
function sequenceOf(element) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (sequenceOf$$inlined$Sequence$1())(element);
}
function flatten(_this__u8e3s4) {
  return flatten_0(_this__u8e3s4, flatten$lambda);
}
function sequenceOf_0(elements) {
  return asSequence(elements);
}
function generateSequence_0(seedFunction, nextFunction) {
  return new (GeneratorSequence())(seedFunction, nextFunction);
}
function calcNext($this) {
  while ($this.iterator_1.hasNext_bitz1p_k$()) {
    var item = $this.iterator_1.next_20eer_k$();
    if ($this.this$0__1.predicate_1(item) === $this.this$0__1.sendWhen_1) {
      $this.nextItem_1 = item;
      $this.nextState_1 = 1;
      return Unit_instance;
    }
  }
  $this.nextState_1 = 0;
}
var FilteringSequence$iterator$1Class;
function FilteringSequence$iterator$1() {
  if (FilteringSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.iterator_1 = this$0.sequence_1.iterator_jk1svi_k$();
        this.nextState_1 = -1;
        this.nextItem_1 = null;
      }
      next_20eer_k$() {
        if (this.nextState_1 === -1) {
          calcNext(this);
        }
        if (this.nextState_1 === 0)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var result = this.nextItem_1;
        this.nextItem_1 = null;
        this.nextState_1 = -1;
        return result;
      }
      hasNext_bitz1p_k$() {
        if (this.nextState_1 === -1) {
          calcNext(this);
        }
        return this.nextState_1 === 1;
      }
    }
    initMetadataForClass($);
    FilteringSequence$iterator$1Class = $;
  }
  return FilteringSequence$iterator$1Class;
}
var FilteringSequenceClass;
function FilteringSequence() {
  if (FilteringSequenceClass === VOID) {
    class $ {
      constructor(sequence, sendWhen, predicate) {
        sendWhen = sendWhen === VOID ? true : sendWhen;
        this.sequence_1 = sequence;
        this.sendWhen_1 = sendWhen;
        this.predicate_1 = predicate;
      }
      iterator_jk1svi_k$() {
        return new (FilteringSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'FilteringSequence', VOID, VOID, [Sequence()]);
    FilteringSequenceClass = $;
  }
  return FilteringSequenceClass;
}
var TransformingSequence$iterator$1Class;
function TransformingSequence$iterator$1() {
  if (TransformingSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.iterator_1 = this$0.sequence_1.iterator_jk1svi_k$();
      }
      next_20eer_k$() {
        return this.this$0__1.transformer_1(this.iterator_1.next_20eer_k$());
      }
      hasNext_bitz1p_k$() {
        return this.iterator_1.hasNext_bitz1p_k$();
      }
    }
    initMetadataForClass($);
    TransformingSequence$iterator$1Class = $;
  }
  return TransformingSequence$iterator$1Class;
}
var TransformingSequenceClass;
function TransformingSequence() {
  if (TransformingSequenceClass === VOID) {
    class $ {
      constructor(sequence, transformer) {
        this.sequence_1 = sequence;
        this.transformer_1 = transformer;
      }
      iterator_jk1svi_k$() {
        return new (TransformingSequence$iterator$1())(this);
      }
      flatten_u6edcn_k$(iterator) {
        return new (FlatteningSequence())(this.sequence_1, this.transformer_1, iterator);
      }
    }
    initMetadataForClass($, 'TransformingSequence', VOID, VOID, [Sequence()]);
    TransformingSequenceClass = $;
  }
  return TransformingSequenceClass;
}
function ensureItemIterator($this) {
  var itemIterator = $this.itemIterator_1;
  if (!(itemIterator == null) && itemIterator.hasNext_bitz1p_k$()) {
    $this.state_1 = 1;
    return true;
  }
  while ($this.iterator_1.hasNext_bitz1p_k$()) {
    var element = $this.iterator_1.next_20eer_k$();
    var nextItemIterator = $this.this$0__1.iterator_1($this.this$0__1.transformer_1(element));
    if (nextItemIterator.hasNext_bitz1p_k$()) {
      $this.itemIterator_1 = nextItemIterator;
      $this.state_1 = 1;
      return true;
    }
  }
  $this.state_1 = 2;
  $this.itemIterator_1 = null;
  return false;
}
var FlatteningSequence$iterator$1Class;
function FlatteningSequence$iterator$1() {
  if (FlatteningSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.iterator_1 = this$0.sequence_1.iterator_jk1svi_k$();
        this.itemIterator_1 = null;
        this.state_1 = 0;
      }
      next_20eer_k$() {
        if (this.state_1 === 2)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        if (this.state_1 === 0 && !ensureItemIterator(this)) {
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        }
        this.state_1 = 0;
        return ensureNotNull(this.itemIterator_1).next_20eer_k$();
      }
      hasNext_bitz1p_k$() {
        if (this.state_1 === 1)
          return true;
        if (this.state_1 === 2)
          return false;
        return ensureItemIterator(this);
      }
    }
    initMetadataForClass($);
    FlatteningSequence$iterator$1Class = $;
  }
  return FlatteningSequence$iterator$1Class;
}
var FlatteningSequenceClass;
function FlatteningSequence() {
  if (FlatteningSequenceClass === VOID) {
    class $ {
      constructor(sequence, transformer, iterator) {
        this.sequence_1 = sequence;
        this.transformer_1 = transformer;
        this.iterator_1 = iterator;
      }
      iterator_jk1svi_k$() {
        return new (FlatteningSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'FlatteningSequence', VOID, VOID, [Sequence()]);
    FlatteningSequenceClass = $;
  }
  return FlatteningSequenceClass;
}
function emptySequence() {
  return EmptySequence_instance;
}
var DropTakeSequenceClass;
function DropTakeSequence() {
  if (DropTakeSequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTakeSequence', VOID, VOID, [Sequence()]);
    DropTakeSequenceClass = $;
  }
  return DropTakeSequenceClass;
}
var TakeSequence$iterator$1Class;
function TakeSequence$iterator$1() {
  if (TakeSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.left_1 = this$0.count_1;
        this.iterator_1 = this$0.sequence_1.iterator_jk1svi_k$();
      }
      next_20eer_k$() {
        if (this.left_1 === 0)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        this.left_1 = this.left_1 - 1 | 0;
        return this.iterator_1.next_20eer_k$();
      }
      hasNext_bitz1p_k$() {
        return this.left_1 > 0 && this.iterator_1.hasNext_bitz1p_k$();
      }
    }
    initMetadataForClass($);
    TakeSequence$iterator$1Class = $;
  }
  return TakeSequence$iterator$1Class;
}
var TakeSequenceClass;
function TakeSequence() {
  if (TakeSequenceClass === VOID) {
    class $ {
      constructor(sequence, count) {
        this.sequence_1 = sequence;
        this.count_1 = count;
        // Inline function 'kotlin.require' call
        if (!(this.count_1 >= 0)) {
          var message = 'count must be non-negative, but was ' + this.count_1 + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      take_6gva4v_k$(n) {
        return n >= this.count_1 ? this : new (TakeSequence())(this.sequence_1, n);
      }
      iterator_jk1svi_k$() {
        return new (TakeSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TakeSequence', VOID, VOID, [Sequence(), DropTakeSequence()]);
    TakeSequenceClass = $;
  }
  return TakeSequenceClass;
}
function calcNext_0($this) {
  if ($this.iterator_1.hasNext_bitz1p_k$()) {
    var item = $this.iterator_1.next_20eer_k$();
    if ($this.this$0__1.predicate_1(item)) {
      $this.nextState_1 = 1;
      $this.nextItem_1 = item;
      return Unit_instance;
    }
  }
  $this.nextState_1 = 0;
}
var TakeWhileSequence$iterator$1Class;
function TakeWhileSequence$iterator$1() {
  if (TakeWhileSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.iterator_1 = this$0.sequence_1.iterator_jk1svi_k$();
        this.nextState_1 = -1;
        this.nextItem_1 = null;
      }
      next_20eer_k$() {
        if (this.nextState_1 === -1) {
          calcNext_0(this);
        }
        if (this.nextState_1 === 0)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var result = this.nextItem_1;
        this.nextItem_1 = null;
        this.nextState_1 = -1;
        return result;
      }
      hasNext_bitz1p_k$() {
        if (this.nextState_1 === -1) {
          calcNext_0(this);
        }
        return this.nextState_1 === 1;
      }
    }
    initMetadataForClass($);
    TakeWhileSequence$iterator$1Class = $;
  }
  return TakeWhileSequence$iterator$1Class;
}
var TakeWhileSequenceClass;
function TakeWhileSequence() {
  if (TakeWhileSequenceClass === VOID) {
    class $ {
      constructor(sequence, predicate) {
        this.sequence_1 = sequence;
        this.predicate_1 = predicate;
      }
      iterator_jk1svi_k$() {
        return new (TakeWhileSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TakeWhileSequence', VOID, VOID, [Sequence()]);
    TakeWhileSequenceClass = $;
  }
  return TakeWhileSequenceClass;
}
var DistinctSequenceClass;
function DistinctSequence() {
  if (DistinctSequenceClass === VOID) {
    class $ {
      constructor(source, keySelector) {
        this.source_1 = source;
        this.keySelector_1 = keySelector;
      }
      iterator_jk1svi_k$() {
        return new (DistinctIterator())(this.source_1.iterator_jk1svi_k$(), this.keySelector_1);
      }
    }
    initMetadataForClass($, 'DistinctSequence', VOID, VOID, [Sequence()]);
    DistinctSequenceClass = $;
  }
  return DistinctSequenceClass;
}
var EmptySequenceClass;
function EmptySequence() {
  if (EmptySequenceClass === VOID) {
    class $ {
      iterator_jk1svi_k$() {
        return EmptyIterator_instance;
      }
      take_6gva4v_k$(n) {
        return EmptySequence_instance;
      }
    }
    initMetadataForObject($, 'EmptySequence', VOID, VOID, [Sequence(), DropTakeSequence()]);
    EmptySequenceClass = $;
  }
  return EmptySequenceClass;
}
var EmptySequence_instance;
function EmptySequence_getInstance() {
  return EmptySequence_instance;
}
function calcNext_1($this) {
  $this.nextItem_1 = $this.nextState_1 === -2 ? $this.this$0__1.getInitialValue_1() : $this.this$0__1.getNextValue_1(ensureNotNull($this.nextItem_1));
  $this.nextState_1 = $this.nextItem_1 == null ? 0 : 1;
}
var GeneratorSequence$iterator$1Class;
function GeneratorSequence$iterator$1() {
  if (GeneratorSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.nextItem_1 = null;
        this.nextState_1 = -2;
      }
      next_20eer_k$() {
        if (this.nextState_1 < 0) {
          calcNext_1(this);
        }
        if (this.nextState_1 === 0)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this.nextItem_1;
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.nextState_1 = -1;
        return result;
      }
      hasNext_bitz1p_k$() {
        if (this.nextState_1 < 0) {
          calcNext_1(this);
        }
        return this.nextState_1 === 1;
      }
    }
    initMetadataForClass($);
    GeneratorSequence$iterator$1Class = $;
  }
  return GeneratorSequence$iterator$1Class;
}
var GeneratorSequenceClass;
function GeneratorSequence() {
  if (GeneratorSequenceClass === VOID) {
    class $ {
      constructor(getInitialValue, getNextValue) {
        this.getInitialValue_1 = getInitialValue;
        this.getNextValue_1 = getNextValue;
      }
      iterator_jk1svi_k$() {
        return new (GeneratorSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'GeneratorSequence', VOID, VOID, [Sequence()]);
    GeneratorSequenceClass = $;
  }
  return GeneratorSequenceClass;
}
function flatten_0(_this__u8e3s4, iterator) {
  if (_this__u8e3s4 instanceof TransformingSequence()) {
    return (_this__u8e3s4 instanceof TransformingSequence() ? _this__u8e3s4 : THROW_CCE()).flatten_u6edcn_k$(iterator);
  }
  return new (FlatteningSequence())(_this__u8e3s4, flatten$lambda_0, iterator);
}
var DistinctIteratorClass;
function DistinctIterator() {
  if (DistinctIteratorClass === VOID) {
    class $ extends AbstractIterator() {
      constructor(source, keySelector) {
        super();
        this.source_1 = source;
        this.keySelector_1 = keySelector;
        this.observed_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
      }
      computeNext_o8do8q_k$() {
        while (this.source_1.hasNext_bitz1p_k$()) {
          var next = this.source_1.next_20eer_k$();
          var key = this.keySelector_1(next);
          if (this.observed_1.add_utx5q5_k$(key)) {
            this.setNext_vbbbu2_k$(next);
            return Unit_instance;
          }
        }
        this.done_wskjm6_k$();
      }
    }
    initMetadataForClass($, 'DistinctIterator');
    DistinctIteratorClass = $;
  }
  return DistinctIteratorClass;
}
var sequenceOf$1Class;
function sequenceOf$1() {
  if (sequenceOf$1Class === VOID) {
    class $ {
      constructor($element) {
        this.$element_1 = $element;
        this._hasNext_1 = true;
      }
      next_20eer_k$() {
        if (!this._hasNext_1)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        this._hasNext_1 = false;
        return this.$element_1;
      }
      hasNext_bitz1p_k$() {
        return this._hasNext_1;
      }
    }
    initMetadataForClass($);
    sequenceOf$1Class = $;
  }
  return sequenceOf$1Class;
}
var sequenceOf$$inlined$Sequence$1Class;
function sequenceOf$$inlined$Sequence$1() {
  if (sequenceOf$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($element) {
        this.$element_1 = $element;
      }
      iterator_jk1svi_k$() {
        return new (sequenceOf$1())(this.$element_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Sequence()]);
    sequenceOf$$inlined$Sequence$1Class = $;
  }
  return sequenceOf$$inlined$Sequence$1Class;
}
function flatten$lambda(it) {
  return it.iterator_jk1svi_k$();
}
function flatten$lambda_0(it) {
  return it;
}
//region block: init
EmptySequence_instance = new (EmptySequence())();
//endregion
//region block: exports
export {
  DistinctSequence as DistinctSequence1lbisrkxedews,
  DropTakeSequence as DropTakeSequence18qfczyunxcax,
  FilteringSequence as FilteringSequence3rfik2d45zn1y,
  FlatteningSequence as FlatteningSequence1gb46kmahgjp0,
  TakeSequence as TakeSequencecj2mz1r3ww35,
  TakeWhileSequence as TakeWhileSequencew23yaim82axu,
  TransformingSequence as TransformingSequence3gzv034v2j93f,
  emptySequence as emptySequence25zpp7hgtqwdd,
  flatten as flatten21nlxz4anepug,
  generateSequence as generateSequence118suk3hffuuw,
  generateSequence_0 as generateSequence2pi96ci7lpz88,
  sequenceOf_0 as sequenceOf1mtha40gp6gat,
  sequenceOf as sequenceOfdrc6uefhtiet,
};
//endregion

//# sourceMappingURL=Sequences.mjs.map
